//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.NcmClearanceBuilder.js";
import "../CAM/CAM.FeedsBuilder.js";
import "../CAM/CAM.ArcOutputTypeCiBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../no/SelectNXObjectList.js";
import "../CAM/CAM.ToolAxisFixed.js";
import "../no/SelectObjectList.js";
let d=[[[1,"ClearanceBuilder",0,"CAM.NcmClearanceBuilder",0],[0,"ControlPoint",1,0],[0,"Cycle",1,0],[1,"FeedsBuilder",0,"CAM.FeedsBuilder",0],[0,"InProcessWorkpiece",1,0],[0,"InspectionArea",1,0],[0,"InspectionCycle",1,0],[0,"InspectionDepth",1,0],[0,"InspectionOffset",1,0],[0,"IntersectionStrategy",1,0],[0,"MotionOutput",1,0],[1,"MotionOutputTypeBuilder",0,"CAM.ArcOutputTypeCiBuilder",0],[1,"PartStockBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"SelectFeatureGeometry",0,"SelectNXObjectList",0],[0,"SelectionMethod",1,0],[1,"ToolAxisFixed",0,"CAM.ToolAxisFixed",0],[0,"TrackingPointName",0,0]],[[[],"ShowGeometry",{},0,0],[[],"CycleLock",{},0,0],[[],"ProbingParameters",{},0,0],[["count"],"GetInspectDirection",{R_:{direction:""}},0,0],[["direction"],"SetInspectDirection",{},1,0],[[],"FeatureRemove",{},0,0],[[],"FeatureMoveUp",{},0,0],[[],"FeatureMoveDown",{},0,0],[[],"InspectionDepthLock",{},0,0],[[],"InspectionOffsetLock",{},0,0],[[],"InspectionCycleLock",{},0,0],[[],"ProcessSelectedGeometry",{},0,0],[[],"ProcessSelectedCycle",{},0,0],[[],"CreateToolpathMoves",{},0,0],[[],"InitializeProbingGeometry",{},0,0],[["geomTag"],"AppendProbingGeometry",{},1,0],[["cycleName"],"ResetCycleParameters",{},1,0],[["parameterName","stringValue"],"SetParameterStringValue",{},2,0],[["parameterName","integerValue"],"SetParameterIntegerValue",{},2,0],[["parameterName","enumValue"],"SetParameterEnumValue",{},2,0],[["parameterName","doubleValue"],"SetParameterDoubleValue",{},2,0],[["parameterName","logicalValue"],"SetParameterLogicalValue",{},2,0],[["parameterName","toggleState"],"SetParameterToggleState",{},2,0],[["parameterName"],"PushParameterButton",{},1,0],[["parameterName","objects"],"SetParameterSelection",{},2,0],[["parameterName","lockState"],"SetParameterLockState",{},2,0],[["parameterName","checkboxState"],"SetParameterCheckboxState",{},2,0],[["trackingPointName"],"SetTrackingPointName",{},1,0]],[]];
SPLM.CAM.OnMachineProbingBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.OnMachineProbingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.OnMachineProbingBuilder.ParameterToggleState = Object.freeze({
    "Off" : "Off", "On" : "On"});

SPLM.CAM.OnMachineProbingBuilder.ParameterLockState = Object.freeze({
    "Lock" : "Lock", "Unlock" : "Unlock"});

SPLM.CAM.OnMachineProbingBuilder.ParameterCheckbox = Object.freeze({
    "Hide" : "Hide", "Unchecked" : "Unchecked", "Checked" : "Checked"});

SPLM.CAM.OnMachineProbingBuilder.MotionOutputType = Object.freeze({
    "MachineCycle" : "MachineCycle", "SingleMoves" : "SingleMoves"});

SPLM.CAM.OnMachineProbingBuilder.SelectionMethodType = Object.freeze({
    "Feature" : "Feature", "Faces" : "Faces", "Curves" : "Curves", "Points" : "Points", "Pmi" : "Pmi"});

SPLM.CAM.OnMachineProbingBuilder.InProcessWorkpieceType = Object.freeze({
    "None" : "None", "Use3D" : "Use3D", "Local" : "Local"});

SPLM.CAM.OnMachineProbingBuilder.ControlPointType = Object.freeze({
    "InProcessFeature" : "InProcessFeature", "MachiningFeature" : "MachiningFeature"});

SPLM.CAM.OnMachineProbingBuilder.IntersectionStrategyType = Object.freeze({
    "None" : "None", "Part" : "Part", "Ipw" : "Ipw", "PartandIPW" : "PartandIPW"});

SPLM.CAM.OnMachineProbingBuilder.ToolAxisType = Object.freeze({
    "PlusMZAxis" : "PlusMZAxis", "SpecifyVector" : "SpecifyVector", "Dynamic" : "Dynamic"});

export default SPLM;